export const TAB_PANEL_CONTENT_CONSTS = {
  publicationsNotFound: 'Публикации отсутствуют',
  searchByAuthor: 'Поиск по автору',
  searchByDate: 'Поиск по дате',
  searchByRegion: 'Поиск по региону',
  titleSearchLabel: 'Поиск по заголовку...'
}
